<template>
    <div class="static-page__container">
        <div
            v-if="isLoading"
            class="spinner-container"
        >
            <SpinnerBars/>
        </div>
        <div
            v-else
            class="static-page__content"
        >
            <SanitizedHtml :content="content"/>
        </div>
    </div>
</template>

<script>
    import SanitizedHtml from '@modules/shared/components/SanitizedHtml.vue';

    export default {
        name: 'Wiki',
        props: {
            content: {
                type: String,
                required: true,
            },
            isLoading: {
                type: Boolean,
                required: true,
            },
        },
        components: {
            SanitizedHtml,
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/wiki/components/Wiki.vue